import React from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { WintSuperkollAPIModel as ApiModels, WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
//#endregion
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts, StyledButton } from "components/common";
import {
  useCreateInvoice,
  useRecurringInvoiceFilterDefinition,
  RecurringInvoiceListView,
  useInvoicePermissions,
} from "components/invoice";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RecurringInvoicesReport: React.FC = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter } =
    useRecurringInvoiceFilterDefinition();
  const onCreateInvoice = useCreateInvoice();

  const { canUseRecurringInvoices, canCreateInvoices } = useInvoicePermissions();

  return (
    <PageLayouts.DashboardLayout<InvoiceFormTypes.RecurringInvoiceFilter>
      entityKey={0}
      hasPermissions={canUseRecurringInvoices}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RecurringInvoices)}
      topRightButtons={
        <DashboardButtonGroup
          buttons={
            canCreateInvoices
              ? [
                  <StyledButton size="sm" onClick={onCreateInvoice}>
                    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreateInvoice)}
                  </StyledButton>,
                  ACTION_SEPARATOR,
                  <FilterButton />,
                ]
              : [<FilterButton />]
          }
        />
      }
      filterFields={filterFormFields}
      initialFilter={{
        status: recurringInvoiceService.getStates().filter((s) => s.id !== ApiModels.RecurringInvoiceState.Stopped),
      }}
      filterQueryStateHandler={filterQueryStateHandler}
      filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.RecurringInvoice}
      apiToReportFilterFormatter={apiToReportFilterFormatter}
      reportToAPIFilterFormatter={recurringInvoiceService.reportToAPIFilter}
    >
      <RecurringInvoiceListView />
    </PageLayouts.DashboardLayout>
  );
};

export default RecurringInvoicesReport;
